import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { MenuService } from '../../services/menu.service';
import { Subscription } from 'rxjs';
import { IMenu } from '../../models/menu-inteface';

import { UsuarioService } from '../../services/usuario.service';
import { DatosCompartidosService } from 'src/app/features/user-sing-in/services/datos-compartidos.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  menu: IMenu[] = [];
  @ViewChild('btnCollapsed') btnCollapsed: ElementRef;

  urlKeycloak: string = '';
  clientIdKeycloak: string = '';
  realmKeycloak: string = '';

  urlSilpa: string = '';
  urlSilpaRegistro: string = '';
  activarVitalAnteriror = true;

  menuService = inject(MenuService);

  subscriptions: Subscription = new Subscription();

  urlPattern = /vital-publico\.minambiente\.gov\.co/;
  urlInfo: string = '/actualizacion-usuario';
  tokenNumber: number = 0;
  refreshTime: number = 400;
  closeUserSession: number = 0;

  logoutURL: string = '';
  interval: NodeJS.Timeout;
  mostrar_modal: boolean = false;
  complete_registro: boolean = false;
  token: string = '';
  mensajeAuthRequerida: string = '<div>      <div class="modal-icon text-center">                  <span class="modal-icon-govco modal-warning-icon"></span>      </div>      <h4 class="modal-title-govco warning-govco text-center">Para Ingresar a este sistema necesita iniciar sesión</h4>      <p class="text-center">A continuación, será redirigido al inicio de sesión, cuando este autenticado vuelva a hacer clic en esta opción!</p>  </div>';
  mensajeCompleteRegistro: string = '<div>      <div class="modal-icon text-center">                  <span class="modal-icon-govco modal-warning-icon"></span>      </div>      <h4 class="modal-title-govco warning-govco text-center">Antes de acceder al sistema, complete el registro</h4>      <p class="text-center">Por favor, diligencie el formulario en pantalla y haga clic en <strong>Guardar</strong> para continuar con el proceso de acceso a los trámites.</p>  </div>';

  constructor(private usuarioService: UsuarioService,
    private datosCompartidos: DatosCompartidosService) {
    this.urlKeycloak = environment.URL_KEYCLOAK;
    this.clientIdKeycloak = environment.CLIENT_ID_KEYCLOAK;
    this.realmKeycloak = environment.REALM_KEYCLOAK;
    this.urlSilpa = environment.URL_VITAL_OLD + '/Silpa/TestSilpa/Security/Login.aspx';
    this.urlSilpaRegistro = environment.URL_VITAL_OLD + '/SILPA_UT_PRE/Datospersonales.aspx?reg=registro';
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  ngOnInit(): void {

    this.subscriptions.add(
      this.menuService.getMenu().subscribe((menu) => {
        menu = this.sortByOrder(menu);
        menu.forEach(item => {
          if (item.children) {
            item.children = this.sortByOrder(item.children);
            item.children.forEach(child => {
              if (child.children) {
                child.children = this.sortByOrder(child.children);
              }
            });
          }
        });
        this.menu = this.modifyUrls(menu)
      }
      )
    );

    this.datosCompartidos.tokenNumber$.subscribe(
      (token: number) => { this.tokenNumber = token; }
    );

    this.datosCompartidos.token$.subscribe(
      (token: string) => {
        if (token) { this.activarVitalAnteriror = false; 
          this.token = token;
         }
      }
    );

    this.datosCompartidos.closeUserSession$.subscribe(
      (closeSession: number) => {
        this.closeUserSession = closeSession;
      }
    );



    this.interval = setInterval(function () {
      console.log("MenuComponent : setInterval");
      this.datosCompartidos.increaseTokenNumber();
    }.bind(this), 240000);

  }



  itemSeleccionadoReporte(id: any, seccion: boolean) {
    if (seccion) {
      const dropdownSeccion = document.getElementById(
        'dropdown-menu-seccion-' + id
      );
      dropdownSeccion.classList.remove('show');
      const dropdownNav = document.getElementById('dropdown-menu-nav' + id);
      dropdownNav.classList.remove('show');
      dropdownNav.classList.remove('active');
      const ariaExpanded = dropdownNav.getAttribute('aria-expanded') === 'true';
      dropdownNav.setAttribute('aria-expanded', (!ariaExpanded).toString());
    } else {
      const dropdown = document.getElementById('dropdown-menu-' + id);
      if (dropdown) dropdown.classList.remove('show');
      const dropdownNav = document.getElementById('dropdown-menu-nav' + id);
      if (dropdownNav) {
        dropdownNav.classList.remove('show');
        const ariaExpanded =
          dropdownNav.getAttribute('aria-expanded') === 'true';
        if (ariaExpanded)
          dropdownNav.setAttribute('aria-expanded', (!ariaExpanded).toString());
      }
    }

    const btn = this.btnCollapsed.nativeElement;
    const navBar = document.getElementById('navbarNavMinAmb');
    navBar.classList.remove('show');
    btn.classList.add('collapsed');
  }

  returnClassList(item: any) {
    if (item.megaMenu === true) {
      return item.megaMenu === true ? 'dropdown has-megamenu-menu-govco' : '';
    } else {
      return item.children.length > 0 ? 'dropdown' : '';
    }
  }

  redirectTo(url: string) {
    location.href = url;
  }

  getToken(tokenResolved: any) {
    localStorage.setItem('keycloak-token', tokenResolved);
    this.datosCompartidos.setToken(tokenResolved);
    if (!window.location.href.includes('actualizacion-usuario')) {
      this.usuarioService.procesarToken(tokenResolved);
    }
  }
  getUserInfo(userInfoResolved: any) {    
    this.datosCompartidos.setUserInfo(userInfoResolved);
    
  }

  getUrlLogOut(logoutURL) {
    this.datosCompartidos.setLogoutUrl(logoutURL);
  }

  // active el siguiente metodo para que se muestre el modal de autenticacion cuando el usuatio no tenga sesion de autenticacion digital activa
  comprobarOpcion(itemChildren){
    console.log("MenuComponent : comprobarOpcion", itemChildren);
    if(itemChildren.nombre.includes("Tramites y servicios ambientales")){
      console.log("MenuComponent : comprobarOpcion", itemChildren);
      this.mostrarModal(itemChildren);
    }else{
      window.location.href = itemChildren.urlHref;
    }
  }


  mostrarModal(itemChildren): void {
    if (!this.token) { //recuperar token
      this.mostrar_modal = true;
      return;
    }

    // si el usuario no esta registrado en vital se inicia el proceso de registro
    const registoCompletado = this.datosCompartidos.getRegistradoEnVital()
    if(!registoCompletado){
      this.complete_registro = true;
      console.log('mostrarModal:complete_registro', registoCompletado);
      return;
    }

    const paramName = itemChildren.urlHref.includes('?') ? '&kyc=' : '?kyc=';
    const URL = `${itemChildren.urlHref}${paramName}${this.token}`;
    window.location.href = URL;
  }

  onCloseModal(){
    const redirectURL = window.location.href;
    const authURL = `${environment.URL_KEYCLOAK}realms/${environment.REALM_KEYCLOAK}/protocol/openid-connect/auth?client_id=${environment.CLIENT_ID_KEYCLOAK}&redirect_uri=${redirectURL}&response_type=code&scope=openid&kc_idp_hint=scd-auth`
    this.mostrar_modal = false;
    window.location.href = authURL;
  }

  onCloseModalCompleteRegistro(){
    this.complete_registro = false;
    if(!window.location.href.includes('registro-usuario')){
      window.location.href = `/registro-usuario`;
    }
  }

  modifyUrls(menuItems: any) {

    const urlPattern = environment.VITAL_DOMINIO_REGEX
    return menuItems.map(item => {
      if (item.url && urlPattern.test(item.url)) {
        const matchedUrl = item.url.match(urlPattern);
        if (matchedUrl) {
          item.url = item.url.slice(matchedUrl.index! + matchedUrl[0].length);
        }
      }
      else if (!item.routerLink) {
        item.url = null
      }

      if (item.routerLink) {
        if (urlPattern.test(item.routerLink)) {
          const matchedRouterLink = item.routerLink.match(urlPattern);
          if (matchedRouterLink) {
            item.routerLink = item.routerLink.slice(matchedRouterLink.index! + matchedRouterLink[0].length);
          }
        } else {
          item.urlHref = item.routerLink;
          item.routerLink = null;
        }
      }

      if (item.children && item.children.length > 0) {
        item.children = this.modifyUrls(item.children);
      }

      return item;
    });
  }

  sortByOrder(array: any[]): any[] {
    return array.sort((a, b) => a.orden - b.orden);
  }

}
